
















import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Switcher extends Vue {
    private isEnabled: boolean = true;

    private toggle(): boolean {
        this.isEnabled = !this.isEnabled;
        this.$emit('toggle', this.isEnabled);
        return this.isEnabled;
    }
}
